import * as React from 'react'

function ConsentCheckboxOn15() {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="15" height="15" fill="#FFBD35" />
      <path d="M3 7.75L5.84211 10L12 4" stroke="white" strokeWidth="2" />
    </svg>
  )
}

export default ConsentCheckboxOn15
